import React from 'react';
import { Box, Grid } from '@mui/material';
import { ChartSection } from './ChartSection';
import { CurveFitNotes } from './CurveFitNotes';
import { ConfigurationSection } from './ConfigurationSection';
import { useCurveConfig, useChartData } from './hooks';
import { rem, LoadingPage } from '@innovyze/stylovyze';
import { WeibullFormulation } from '@Types';

interface CurveConfigurationProps {
	modelId: string;
	curveConfigId: string;
	industryStandardCurves: {
		curves: {
			key: string;
			displayName: string;
		}[];
		isLoading: boolean;
	};
	failureCount?: number;
	weibullFormulation?: WeibullFormulation;
}

export const CurveConfiguration = ({
	modelId,
	curveConfigId,
	industryStandardCurves,
	failureCount,
	weibullFormulation = WeibullFormulation.TWO_PARAMETER,
}: CurveConfigurationProps) => {
	const curveState = useCurveConfig(modelId, curveConfigId, industryStandardCurves, weibullFormulation);
	const { selectedLines, setSelectedLines, availableDataSeries, chartOptions } = useChartData(curveState);

	return (
		<>
			{curveState.curveConfig.inProcess ? (
				<Box style={{ padding: rem(16) }}>
					<LoadingPage />
				</Box>
			) : (
				<Grid container spacing={2} style={{ padding: rem(16) }} alignItems="center" justifyContent="center">
					<Grid item xs={8}>
						<ChartSection
							availableDataSeries={availableDataSeries}
							selectedLines={selectedLines}
							setSelectedLines={setSelectedLines}
							chartOptions={chartOptions}
							footer={<CurveFitNotes curveState={curveState} />}
						/>
					</Grid>
					<Grid item xs={4}>
						<ConfigurationSection
							curveState={curveState}
							industryStandardCurves={industryStandardCurves}
							currentCurveConfigId={curveConfigId}
							modelId={modelId}
							failureCount={failureCount}
						/>
					</Grid>
				</Grid>
			)}
		</>
	);
};
